import { MARGINS_BLOCKS } from '@features/cms/const';
import { TMarginsTypes } from '@features/cms/typescript';
import theme from '@styles/theme';
export default {
  categoryHeaderContainer: (bg: string, marginTop: TMarginsTypes, marginBottom: TMarginsTypes) => ({
    minHeight: ['auto', 'auto', 'auto', '32.2916667vw'],
    bg,
    display: 'flex',
    flexWrap: ['wrap', 'wrap', 'wrap', 'nowrap'],
    mt: MARGINS_BLOCKS[marginTop],
    mb: MARGINS_BLOCKS[marginBottom],
    position: 'relative',
    zIndex: theme.zIndex.documentUp
  }),
  headerContent: {
    width: ['100%', '100%', '100%', '41.3020833vw'],
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    p: ['110px 40px 40px', '110px 40px 40px', '136px 64px 64px', '126.5px 0 40px 10.15625vw'],
    '.display__four': {
      width: ['100%', '100%', '100%', 'max-content'],
      wordWrap: 'keep-all',
      position: 'relative',
      zIndex: theme.zIndex.documentUp
    }
  },
  descriptionText: (color = theme.rawColors.neutralWhite) => ({
    color,
    width: ['100%', '100%', '100%', '23.0729167vw']
  }),
  imageContainer: (height?: number) => ({
    position: 'relative',
    minHeight: ['auto', 'auto', 'auto', '32.2916667vw'],
    width: ['100%', '100%', '100%', 'calc(100vw - 41.3020833vw)'],
    height: ['75vw', '75vw', '75vw', `calc(${height}px + 294.5px)`],
    img: {
      objectFit: 'cover',
      wordBreak: 'keep-all'
    }
  })
};